import React from 'react';
import styled from 'styled-components';
import { DynamicLink } from 'packages/smart-home-support/components';
import { PartnerContent } from 'packages/smart-home-support/partner';
import { getBreakpoint, getChatLinkProps, getPhoneUrl } from '../../utils';
import { Button, ExpertPortrait, Heading2, TabContent, Well, WellSubheading } from '../../styles';
import { Call, Chat } from './icons';
import { LinkId } from 'packages/smart-home-support/constants';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';

const breakpoint = getBreakpoint();

const s = {
  Button,
  Heading2,
  WellSubheading,
  Well: styled(Well)`
    box-sizing: border-box;
    @media ${breakpoint} {
      width: 100%;
    }
  `,
  TabContent: styled(TabContent)`
    @media ${breakpoint} {
      display: flex;
      font-size: 20px;
    }
  `,
  WellContent: styled.div`
    display: flex;
    margin-top: 15px;
  `,
  Actions: styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: center;
  `,
  Action: styled(DynamicLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    text-decoration: none;
    color: #000;
  `,
  ActionIcon: styled.div`
    height: 18px;
  `,
  ActionLabel: styled.div`
    font-size: 16px;
    margin-top: 10px;
    font-weight: bold;
  `,
  ExpertPortrait: styled(ExpertPortrait)`
    margin-right: 10px;
    width: 100px;
    height: 70px;
    @media ${BREAK_POINTS.desktop} {
      width: 80px;
      height: 56px;
    }
    @media ${BREAK_POINTS.desktopBig} {
      width: 100px;
      height: 70px;
    }
  `,
};

const TechCoachCTA: React.FC<{ chatLinkId: LinkId; callLinkId: LinkId }> = (props) => {
  return (
    <s.Well>
      <s.Heading2>
        <PartnerContent Sprint="Tech Expert is here to help">Tech Coach is here to help</PartnerContent>
      </s.Heading2>
      <s.WellSubheading>
        <PartnerContent Sprint="Have questions?">Chat or call, anytime day or night.</PartnerContent>
      </s.WellSubheading>
      <s.WellContent>
        <s.ExpertPortrait />
        <s.Actions>
          <s.Action id={props.chatLinkId} {...getChatLinkProps()}>
            <s.ActionIcon>
              <Chat />
            </s.ActionIcon>
            <s.ActionLabel>Chat</s.ActionLabel>
          </s.Action>
          <s.Action id={props.callLinkId} to={getPhoneUrl()}>
            <s.ActionIcon>
              <Call />
            </s.ActionIcon>
            <s.ActionLabel>Call</s.ActionLabel>
          </s.Action>
        </s.Actions>
      </s.WellContent>
    </s.Well>
  );
};

export default TechCoachCTA;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/TechCoachCTA/TechCoachCTA.tsx